<template>
  <div class="form tab-content">
    <!--<input-field
      :value="orientation"
      :label="$t('Orientation')"
      size="small"
      inputType="other"
      :fieldDisabled="true"
    >
      <treeselect
        v-model="orientation"
        :options="orientationOptions"
        :disabled="readOnly"
        class="form-input-select"
        disableFuzzyMatching
      />
    </input-field>-->
    <input-field
      :value="getValueInObject('tp_pe_angle')"
      @input="updateValue('tp_pe_angle', $event)"
      :label="$t('Angle') + ' (grads)'"
      size="medium"
      inputType="number"
      :step="0.01"
      :max="400"
      :fieldDisabled="readOnly"
    />
    <!--<input-field
      v-if="orientation === 'extremity' || orientation === 'bisectrix'"
      :value="origin"
      :label="$t('Origin')"
      size="small"
      inputType="other"
      :fieldDisabled="true"
    >
      <treeselect
        v-model="origin"
        :options="originOptions"
        :disabled="readOnly"
        class="form-input-select"
        disableFuzzyMatching
      />
    </input-field>
    <input-field
      v-if="orientation === 'bisectrix'"
      :value="destination"
      :label="$t('Destination')"
      size="small"
      inputType="other"
      :fieldDisabled="true"
    >
      <treeselect
        v-model="destination"
        :options="destinationOptions"
        :disabled="readOnly"
        class="form-input-select"
        disableFuzzyMatching
      />
    </input-field>-->
  </div>
</template>

<script>
import { poleEffortModuleTabsMixin } from "@/mixins/forms/poleEffortTabsMixin";
import InputField from "../../_Molecules/InputField";
export default {
  name: "PoleAngleTab",

  components: { InputField },

  mixins: [poleEffortModuleTabsMixin],

  data() {
    return {
      orientation: undefined,
      origin: undefined,
      destination: undefined
    };
  },

  computed: {
    orientationOptions() {
      return [
        { id: "manual", label: this.$i18n.tc("Manual", 1) },
        { id: "extremity", label: this.$i18n.t("Extremity") },
        { id: "bisectrix", label: this.$i18n.t("Bisectrix") }
      ];
    },

    originOptions() {
      return [];
    },

    destinationOptions() {
      return [];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/PoleEffortModule/AngleTab.vue